import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import Vue from "vue";

const state = {
    S_EMPLOYEE_ID: '',
    S_EMPLOYEE_INFO: [],
}
const getters = {
    G_EMPLOYEE_ID() {
        return state.S_EMPLOYEE_ID;
    },
    G_EMPLOYEE_INFO() {
        return state.S_EMPLOYEE_INFO;
    }
}
const mutations = {
    M_SET_S_EMPLOYEE_ID(state, val) {
        state.S_EMPLOYEE_ID = val;
    },
    M_SET_S_EMPLOYEE_INFO(state, val) {
        state.S_EMPLOYEE_INFO = val;
    }
}
const actions = {
    async A_EMPLOYEE_INFO({ commit }, body) {
        try {
            const params = {
                employee_id: body
            }
            const { data } = await EmployeeService.getEmployeeDashboard(params);
            commit('M_SET_S_EMPLOYEE_INFO', data[0]);
            return data[0];
        } catch (error) {
            throw error;
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}